<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-tabs
        v-model="activeTab"
        color="primary"
        slider-color="primary"
        background-color="grey lighten-5"
        grow
    >
        <v-tab>
            <v-icon left small>mdi-account-group</v-icon>
            유저 리스트
        </v-tab>
        <v-tab>
            <v-icon left small>mdi-shield-search</v-icon>
            유저 세스코
            <v-chip
                v-if="sesco_list.length > 0"
                x-small
                color="red lighten-1"
                text-color="white"
                class="ml-2"
            >{{ sescoSuspectCount }}</v-chip>
        </v-tab>
    </v-tabs>
    <v-divider></v-divider>

    <v-tabs-items v-model="activeTab">
    <!-- ===== 탭1: 유저 리스트 ===== -->
    <v-tab-item>
    <div class="userlist-header">
      <div class="userlist-header__title">
        <v-icon dark class="mr-2">mdi-account-group</v-icon>
        <span>유저 리스트</span>
      </div>
      <v-row align="center" no-gutters class="userlist-header__search">
        <v-col cols="12" sm="4" class="pa-1">
          <v-select
              v-model="selected_sort_type"
              :items="user_sort_type"
              label="검색 타입"
              item-text="name"
              item-value="id"
              dense
              solo
              flat
              hide-details
              background-color="rgba(255,255,255,0.15)"
              dark
          ></v-select>
        </v-col>
        <v-col cols="12" sm="5" class="pa-1">
          <v-text-field
              v-model="search_keyword"
              label="유저 아이디 입력"
              hide-details
              dense
              solo
              flat
              background-color="rgba(255,255,255,0.15)"
              dark
              append-icon="mdi-magnify"
              @click:append="OnClick_SearchUser()"
              @keyup.enter="OnClick_SearchUser()"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3" class="pa-1">
          <v-btn color="white" outlined dark small block @click="OnClick_SearchUser()">
            <v-icon left small>mdi-magnify</v-icon>검색
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-list two-line>
    <v-list-item-group
        active-class="pink--text"
        multiple
    >
    <v-data-table
        :footer-props="{'items-per-page-options':[100, -1]}"
        :headers="selected_sort_type === 'COIN' || selected_sort_type === 'EARN_COIN_TOTAL'
            ? headers_type_coin
            : selected_sort_type === 'GEM' || selected_sort_type === 'EARN_GEM_TOTAL'
                ? headers_type_gem
                : selected_sort_type === 'BP'
                    ? headers_type_bp
                    : selected_sort_type === 'REFEREE'
                        ? headers_type_referee
                        : headers"

        :items="search_result"
        :loading="loadingData"
        >
        <template v-slot:item="row">
            <tr>
            <td>{{row.item.USER_ID}}</td>
            <td>{{row.item.NICK}}</td>
            <td>{{row.item.CREATE_DT}}</td>
            <td>{{ selected_sort_type === 'COIN' || selected_sort_type === 'EARN_COIN_TOTAL' ? GetSortInfo(row.item).toFixed(8) : GetSortInfo(row.item) }}</td>
            <td v-if="selected_sort_type === 'COIN' || selected_sort_type === 'EARN_COIN_TOTAL'">
                {{ typeof GetSortInfo(row.item) === 'number' ? formatCoin_KRW(GetSortInfo(row.item) * (gold_price * gold_price_rate)) : GetSortInfo(row.item) }}원
            </td>
            <td v-if="selected_sort_type === 'REFEREE'">
                <v-btn class="mx-2" fab dark small color="indigo lighten-3" @click="Show_UserReferees(row.item)">
                    <v-icon dark>mdi-account-multiple-plus</v-icon>
                </v-btn>
            </td>
            <td>
                <v-btn class="mx-2" fab dark small color="indigo lighten-3" @click="OnClickUser_Mail(row.item)">
                    <v-icon dark>mdi-email-plus</v-icon>
                </v-btn>
                <v-btn class="mx-2" fab dark small color="blue darken-1" @click="OnClickUserInfo(row.item)">
                    <v-icon dark>mdi-magnify</v-icon>
                </v-btn>
            </td>
            <!-- <td v-if='!isLive' >
                <v-btn class="mx-2" fab dark small color="red" @click="clickDeleteUserBtn(row.item.USER_ID)">
                    <v-icon dark>mdi-delete</v-icon>
                </v-btn>
            </td> -->
            </tr>
        </template>
    </v-data-table>
        </v-list-item-group>
    </v-list>
    </v-tab-item>

    <!-- ===== 탭2: 유저 세스코 (어뷰징 분석) ===== -->
    <v-tab-item>
        <div class="sesco-header">
            <div class="sesco-header__title">
                <v-icon dark class="mr-2">mdi-shield-search</v-icon>
                <span>유저 세스코 — 추천 어뷰징 분석</span>
                <v-spacer></v-spacer>
                <v-chip small color="white" text-color="red darken-2" class="ml-2">
                    <v-icon left x-small>mdi-information</v-icon>
                    위험 점수 ≥ 60 = 의심
                </v-chip>
            </div>
            <v-row align="center" no-gutters class="sesco-header__controls">
                <v-col cols="6" sm="2" class="pa-1">
                    <v-text-field
                        v-model.number="sesco_min_referees"
                        label="최소 추천인 수"
                        type="number" min="1"
                        dense solo flat hide-details
                        background-color="rgba(255,255,255,0.15)" dark
                    ></v-text-field>
                    <v-tooltip top max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                            <div class="sesco-field-hint" v-bind="attrs" v-on="on">추천인 수 기준 ⓘ</div>
                        </template>
                        <span>
                            추천인을 이 수 <b>이상</b> 보유한 유저만 분석 대상에 포함합니다.<br>
                            값이 작을수록 모수가 늘어나 응답이 느려질 수 있습니다.<br>
                            <b>기본 5명</b> — 보통 5~10 사이가 의미 있는 어뷰징 패턴을 잡기 좋습니다.
                        </span>
                    </v-tooltip>
                </v-col>
                <v-col cols="6" sm="2" class="pa-1">
                    <v-text-field
                        v-model.number="sesco_limit"
                        label="결과 개수"
                        type="number" min="10" max="500"
                        dense solo flat hide-details
                        background-color="rgba(255,255,255,0.15)" dark
                    ></v-text-field>
                    <v-tooltip top max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                            <div class="sesco-field-hint" v-bind="attrs" v-on="on">상위 N명 표시 ⓘ</div>
                        </template>
                        <span>
                            응답으로 받아 표에 표시할 <b>상위 N명</b> 수.<br>
                            정렬은 <b>동일IP점유율 → 추천인 수</b> 순으로 의심도가 높은 순서입니다.<br>
                            <b>기본 50명, 최대 500명</b> — 너무 크게 잡으면 쿼리/렌더 비용이 큽니다.
                        </span>
                    </v-tooltip>
                </v-col>
                <v-col cols="6" sm="3" class="pa-1">
                    <v-checkbox
                        v-model="sesco_include_banned"
                        label="정지유저 포함"
                        dense hide-details dark
                        color="white"
                        class="mt-0"
                    ></v-checkbox>
                    <v-tooltip top max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                            <div class="sesco-field-hint" v-bind="attrs" v-on="on">정지 계정 포함 여부 ⓘ</div>
                        </template>
                        <span>
                            체크하면 이미 <b>이용정지된 유저</b>도 결과에 포함합니다.<br>
                            보통은 끄고(=정지 제외) "아직 살아 있는 의심 계정"만 보는 게 효율적입니다.
                        </span>
                    </v-tooltip>
                </v-col>
                <v-col cols="6" sm="2" class="pa-1">
                    <v-text-field
                        v-model.number="sesco_risk_threshold"
                        label="의심 임계 (위험점수)"
                        type="number" min="0" max="100"
                        dense solo flat hide-details
                        background-color="rgba(255,255,255,0.15)" dark
                    ></v-text-field>
                    <v-tooltip top max-width="320">
                        <template v-slot:activator="{ on, attrs }">
                            <div class="sesco-field-hint" v-bind="attrs" v-on="on">의심 유저 임계값 ⓘ</div>
                        </template>
                        <span>
                            위험점수가 이 값 <b>이상</b>인 유저를 요약 카드의 <b>"의심 유저 수"</b> 로 집계합니다.<br>
                            표에 표시되는 데이터/정렬에는 영향을 주지 않습니다.<br>
                            <b>기본 60</b> — 가중합(0~100) 기준 60 이상이면 사람이 한 번 더 들여다볼 가치가 있습니다.
                        </span>
                    </v-tooltip>
                </v-col>
                <v-col cols="12" sm="3" class="pa-1">
                    <v-btn color="white" outlined dark block @click="LoadSescoList" :loading="sesco_loading">
                        <v-icon left small>mdi-refresh</v-icon>분석 새로고침
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <!-- 요약 카드 4개 -->
        <v-row class="ma-2" no-gutters>
            <v-col cols="6" sm="3" class="pa-1">
                <v-card outlined>
                    <v-card-text class="pa-3 text-center">
                        <div class="text-caption grey--text">분석 대상</div>
                        <div class="text-h5 font-weight-bold primary--text">{{ formatNumber(sescoStats.total) }}명</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="6" sm="3" class="pa-1">
                <v-card outlined :color="sescoStats.suspect > 0 ? 'red lighten-5' : ''">
                    <v-card-text class="pa-3 text-center">
                        <div class="text-caption grey--text">의심 유저 (위험 ≥ {{ sesco_risk_threshold }})</div>
                        <div class="text-h5 font-weight-bold red--text">{{ formatNumber(sescoStats.suspect) }}명</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="6" sm="3" class="pa-1">
                <v-card outlined>
                    <v-card-text class="pa-3 text-center">
                        <div class="text-caption grey--text">평균 추천인 수</div>
                        <div class="text-h5 font-weight-bold">{{ sescoStats.avgReferees.toFixed(1) }}</div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="6" sm="3" class="pa-1">
                <v-card outlined>
                    <v-card-text class="pa-3 text-center">
                        <div class="text-caption grey--text">평균 전화인증률</div>
                        <div class="text-h5 font-weight-bold">{{ sescoStats.avgPhonePct.toFixed(1) }}%</div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- 분석 결과 테이블 -->
        <div style="overflow-x: auto;" class="px-2 pb-2">
            <v-data-table
                :headers="sesco_headers"
                :items="sesco_list_decorated"
                :loading="sesco_loading"
                :footer-props="{'items-per-page-options':[50, 100, -1]}"
                :items-per-page="50"
                :sort-by="['RISK_SCORE','REF_COUNT']"
                :sort-desc="[true, true]"
                multi-sort
                class="elevation-1"
                no-data-text="분석할 데이터가 없습니다. 우측 상단의 '분석 새로고침'을 눌러보세요."
            >
                <template v-slot:item.RISK_SCORE="{ item }">
                    <v-chip
                        small dark
                        :color="riskColor(item.RISK_SCORE)"
                    >
                        <v-icon left x-small>{{ riskIcon(item.RISK_SCORE) }}</v-icon>
                        {{ item.RISK_SCORE }}
                    </v-chip>
                </template>
                <template v-slot:item.REFEREE_PHONE_VERIFIED_PCT="{ item }">
                    <span :class="item.REFEREE_PHONE_VERIFIED_PCT < 30 ? 'red--text font-weight-bold' : ''">
                        {{ item.REFEREE_PHONE_VERIFIED_PCT != null ? item.REFEREE_PHONE_VERIFIED_PCT.toFixed(1) + '%' : '-' }}
                    </span>
                </template>
                <template v-slot:item.REFEREE_AVG_CUR_BP="{ item }">
                    <span :class="item.REFEREE_AVG_CUR_BP != null && item.REFEREE_AVG_CUR_BP < 30 ? 'orange--text font-weight-bold' : ''">
                        {{ item.REFEREE_AVG_CUR_BP != null ? formatCoin(item.REFEREE_AVG_CUR_BP) : '-' }}
                    </span>
                </template>
                <template v-slot:item.REFEREE_TOP_SHARED_IP_PCT="{ item }">
                    <span :class="item.REFEREE_TOP_SHARED_IP_PCT >= 50 ? 'red--text font-weight-bold' : ''">
                        {{ item.REFEREE_TOP_SHARED_IP_PCT != null ? item.REFEREE_TOP_SHARED_IP_PCT.toFixed(1) + '%' : '-' }}
                    </span>
                </template>
                <template v-slot:item.IS_BANNED="{ item }">
                    <v-chip x-small :color="item.IS_BANNED === 'Y' ? 'error' : 'success'" dark>
                        {{ item.IS_BANNED === 'Y' ? '정지' : '활성' }}
                    </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn x-small color="primary" depressed @click="OpenSescoDetail(item)">
                        <v-icon left x-small>mdi-magnify-scan</v-icon>상세
                    </v-btn>
                    <v-btn x-small color="indigo lighten-3" depressed class="ml-1" @click="OnClickUserInfo(item)">
                        <v-icon left x-small>mdi-account-circle</v-icon>유저
                    </v-btn>
                </template>
            </v-data-table>
        </div>

        <v-alert
            v-if="!sesco_loaded && !sesco_loading"
            type="info" border="left" colored-border outlined class="ma-3"
        >
            <strong>유저 세스코 사용법</strong>
            <div class="text-caption mt-1">
                "최소 추천인 수" 이상의 추천인을 가진 유저를 추려, 추천인들의 전화인증률 / 평균 채굴률 / 동일 IP 점유율을 한 번에 보여줍니다.
                상세보기에서 각 추천인의 IP 일치 여부와 빈도를 확인하세요.
            </div>
        </v-alert>
    </v-tab-item>
    </v-tabs-items>
    </v-card>

     <!-- ===== 유저 세스코 상세 다이얼로그 ===== -->
     <v-dialog v-model="sesco_detail_dialog" max-width="1280" scrollable>
         <v-card>
             <v-card-title class="text-h6 red lighten-1 white--text">
                 <v-icon left dark>mdi-shield-search</v-icon>
                 어뷰징 의심 상세 분석
                 <v-spacer></v-spacer>
                 <v-chip
                     v-if="sesco_detail_data && sesco_detail_data.stats"
                     small dark
                     :color="riskColor(sesco_detail_data.stats.RISK_SCORE)"
                 >
                     위험 {{ sesco_detail_data.stats.RISK_SCORE }}
                 </v-chip>
             </v-card-title>
             <v-card-text class="pa-4" style="max-height: 80vh;">
                 <v-progress-linear v-if="sesco_detail_loading" indeterminate color="red"></v-progress-linear>

                 <v-row v-if="sesco_detail_data" no-gutters class="mt-2">
                     <!-- 좌측: 본인 카드 -->
                     <v-col cols="12" md="4" class="pa-2">
                         <v-card outlined>
                             <v-card-subtitle class="font-weight-bold">
                                 <v-icon left small>mdi-account-circle</v-icon>대상 유저
                             </v-card-subtitle>
                             <v-card-text class="pa-3">
                                 <div><strong>USER_ID:</strong> {{ sesco_detail_data.user.USER_ID }}</div>
                                 <div><strong>NICK:</strong> {{ sesco_detail_data.user.NICK }}</div>
                                 <div><strong>가입일:</strong> {{ sesco_detail_data.user.CREATE_DT }}</div>
                                 <div class="mt-2">
                                     <v-chip x-small :color="sesco_detail_data.user.PHONE_VERIFIED === 'Y' ? 'success' : 'grey'" dark class="mr-1">
                                         {{ sesco_detail_data.user.PHONE_VERIFIED === 'Y' ? '폰인증' : '미인증' }}
                                     </v-chip>
                                     <v-chip x-small :color="sesco_detail_data.user.IS_BANNED === 'Y' ? 'error' : 'success'" dark>
                                         {{ sesco_detail_data.user.IS_BANNED === 'Y' ? '정지' : '활성' }}
                                     </v-chip>
                                 </div>
                                 <div class="mt-2"><strong>CUR_BP:</strong> {{ formatCoin(sesco_detail_data.user.CUR_BP || 0) }}</div>
                                 <div><strong>DAILY_BP:</strong> {{ formatCoin(sesco_detail_data.user.DAILY_BP || 0) }}</div>
                                 <div><strong>최근 IP:</strong> <code>{{ sesco_detail_data.user.LAST_LOGIN_IP || '-' }}</code></div>
                                 <div><strong>최근 로그인:</strong> {{ sesco_detail_data.user.LAST_LOGIN_DT || '-' }}</div>
                             </v-card-text>
                         </v-card>
                     </v-col>

                     <!-- 우측 상단: stats -->
                     <v-col cols="12" md="8" class="pa-2">
                         <v-card outlined>
                             <v-card-subtitle class="font-weight-bold">
                                 <v-icon left small>mdi-chart-box</v-icon>위험 시그널 요약
                             </v-card-subtitle>
                             <v-card-text class="pa-3">
                                 <v-row dense>
                                     <v-col cols="6" sm="3">
                                         <div class="text-caption grey--text">전체 추천인</div>
                                         <div class="text-h6">{{ sesco_detail_data.stats.TOTAL_REFEREES }}</div>
                                     </v-col>
                                     <v-col cols="6" sm="3">
                                         <div class="text-caption grey--text">전화인증률</div>
                                         <div class="text-h6" :class="sesco_detail_data.stats.PHONE_VERIFIED_PCT < 30 ? 'red--text' : ''">
                                             {{ sesco_detail_data.stats.PHONE_VERIFIED_PCT.toFixed(1) }}%
                                         </div>
                                     </v-col>
                                     <v-col cols="6" sm="3">
                                         <div class="text-caption grey--text">평균 채굴 (CUR_BP)</div>
                                         <div class="text-h6">{{ formatCoin(sesco_detail_data.stats.AVG_CUR_BP || 0) }}</div>
                                     </v-col>
                                     <v-col cols="6" sm="3">
                                         <div class="text-caption grey--text">정지 추천인</div>
                                         <div class="text-h6" :class="sesco_detail_data.stats.BANNED_COUNT > 0 ? 'red--text' : ''">
                                             {{ sesco_detail_data.stats.BANNED_COUNT }}
                                         </div>
                                     </v-col>
                                     <v-col cols="6" sm="3">
                                         <div class="text-caption grey--text">서로 다른 IP</div>
                                         <div class="text-h6">{{ sesco_detail_data.stats.DISTINCT_IP_COUNT }}</div>
                                     </v-col>
                                     <v-col cols="6" sm="3">
                                         <div class="text-caption grey--text">최다 공유 IP</div>
                                         <div class="text-body-2"><code>{{ sesco_detail_data.stats.TOP_SHARED_IP || '-' }}</code></div>
                                         <div class="text-caption">{{ sesco_detail_data.stats.TOP_SHARED_IP_COUNT }}명 ({{ (sesco_detail_data.stats.TOP_SHARED_IP_PCT || 0).toFixed(1) }}%)</div>
                                     </v-col>
                                     <v-col cols="6" sm="3">
                                         <div class="text-caption grey--text">본인과 같은 IP</div>
                                         <div class="text-h6" :class="sesco_detail_data.stats.SAME_IP_AS_OWNER_COUNT > 0 ? 'orange--text' : ''">
                                             {{ sesco_detail_data.stats.SAME_IP_AS_OWNER_COUNT }}명
                                         </div>
                                     </v-col>
                                     <v-col cols="6" sm="3">
                                         <div class="text-caption grey--text">위험 점수</div>
                                         <v-chip dark :color="riskColor(sesco_detail_data.stats.RISK_SCORE)">
                                             <v-icon left x-small>{{ riskIcon(sesco_detail_data.stats.RISK_SCORE) }}</v-icon>
                                             {{ sesco_detail_data.stats.RISK_SCORE }}
                                         </v-chip>
                                     </v-col>
                                 </v-row>

                                 <!-- IP 빈도 칩 -->
                                 <v-divider class="my-3"></v-divider>
                                 <div class="text-caption grey--text mb-1">IP 빈도 (본인 + 추천인 마지막 IP)</div>
                                 <v-chip
                                     v-for="(count, ip) in sesco_detail_data.ip_frequency"
                                     :key="'ip-' + ip"
                                     small
                                     :color="count >= 3 ? 'red lighten-4' : 'grey lighten-3'"
                                     :text-color="count >= 3 ? 'red darken-3' : ''"
                                     class="ma-1"
                                 >
                                     <code>{{ ip || '(빈값)' }}</code>
                                     <span class="ml-2">×{{ count }}</span>
                                 </v-chip>
                                 <div v-if="!sesco_detail_data.ip_frequency || Object.keys(sesco_detail_data.ip_frequency).length === 0" class="grey--text">
                                     IP 데이터 없음
                                 </div>
                             </v-card-text>
                         </v-card>
                     </v-col>

                     <!-- 추천인 테이블 -->
                     <v-col cols="12" class="pa-2">
                         <v-card outlined>
                             <v-card-subtitle class="font-weight-bold">
                                 <v-icon left small>mdi-account-multiple</v-icon>
                                 추천인 리스트 ({{ (sesco_detail_data.referees || []).length }}명)
                                 <v-chip x-small color="red lighten-4" text-color="red darken-3" class="ml-2">
                                     본인과 IP 동일 행: 빨간색 강조
                                 </v-chip>
                             </v-card-subtitle>
                             <div style="max-height: 50vh; overflow-y: auto;">
                                 <v-data-table
                                     :headers="sesco_detail_headers"
                                     :items="sesco_detail_data.referees || []"
                                     :items-per-page="-1"
                                     hide-default-footer
                                     dense
                                     :item-class="row => row.SHARES_IP_WITH_OWNER === 'Y' ? 'sesco-shared-ip-row' : ''"
                                 >
                                     <template v-slot:item.PHONE_VERIFIED="{ item }">
                                         <v-icon small :color="item.PHONE_VERIFIED === 'Y' ? 'success' : 'grey lighten-1'">
                                             {{ item.PHONE_VERIFIED === 'Y' ? 'mdi-check-circle' : 'mdi-close-circle' }}
                                         </v-icon>
                                     </template>
                                     <template v-slot:item.IS_BANNED="{ item }">
                                         <v-chip x-small :color="item.IS_BANNED === 'Y' ? 'error' : 'success'" dark>
                                             {{ item.IS_BANNED === 'Y' ? '정지' : '활성' }}
                                         </v-chip>
                                     </template>
                                     <template v-slot:item.SHARES_IP_WITH_OWNER="{ item }">
                                         <v-chip x-small v-if="item.SHARES_IP_WITH_OWNER === 'Y'" color="red" dark>
                                             <v-icon left x-small>mdi-alert</v-icon>일치
                                         </v-chip>
                                         <span v-else class="grey--text">-</span>
                                     </template>
                                     <template v-slot:item.LAST_LOGIN_IP="{ item }">
                                         <code>{{ item.LAST_LOGIN_IP || '-' }}</code>
                                     </template>
                                     <template v-slot:item.actions="{ item }">
                                         <v-btn x-small color="indigo lighten-3" depressed @click="OnClickUserInfo(item)">
                                             <v-icon left x-small>mdi-account-circle</v-icon>유저
                                         </v-btn>
                                     </template>
                                 </v-data-table>
                             </div>
                         </v-card>
                     </v-col>
                 </v-row>

                 <v-alert v-if="!sesco_detail_loading && !sesco_detail_data" type="info" outlined>
                     상세 데이터가 없습니다.
                 </v-alert>
             </v-card-text>
             <v-card-actions>
                 <v-spacer></v-spacer>
                 <v-btn text color="primary" @click="sesco_detail_dialog = false">닫기</v-btn>
             </v-card-actions>
         </v-card>
     </v-dialog>

     <v-dialog
        v-model="dialog_referee_list"
        max-width="95%"
        :fullscreen="$vuetify.breakpoint.xsOnly"
        @click:outside="Close_Referee_Dialog"
        @keydown.esc="Close_Referee_Dialog"
        tabindex="0"
    >
    <v-card>
        <v-card-title class="text-h5">
        추천인 리스트 ( {{ dialog_referee_list_items.length }} 명)
        </v-card-title>

        <div style="max-height: 800px; overflow-y: auto;">
        <v-data-table
            :headers="headers_referees"
            :items="dialog_referee_list_items"
            :items-per-page="100"
            :footer-props="{'items-per-page-options':[100, 200, 500, -1]}"
            class="elevation-1"
        >
            <template v-slot:item.NICK="{ item }">
                <b>{{ item.NICK }}</b>
            </template>
            <template v-slot:item.REFEREE_COIN="{ item }">
                {{ formatNumber(item.REFEREE_COIN) }}
            </template>
            <template v-slot:item.FRIEND_SHARE_PER="{ item }">
                <div class="d-flex align-center" style="gap:6px;">
                    <v-text-field
                        :value="share_per_drafts[item.USER_ID] ?? item.FRIEND_SHARE_PER"
                        @input="val => share_per_drafts = { ...share_per_drafts, [item.USER_ID]: val }"
                        type="number"
                        step="0.01" min="0.01" max="0.5"
                        dense hide-details outlined
                        style="max-width:110px;"
                    ></v-text-field>
                    <v-btn
                        x-small
                        color="primary"
                        :disabled="!isShareDirty(item)"
                        :loading="saving_share_per_id === item.USER_ID"
                        @click="Save_FriendSharePer(item)"
                    >저장</v-btn>
                </div>
            </template>
        </v-data-table>
        </div>

        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="Close_Referee_Dialog"
        >
            확인
        </v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import config from '../../config/config';
import store from '../../store';
import { carrygold } from '../../api';
export default {
    name: 'UserList',

    data: () => ({
        activeTab: 0,
        loadingData:false,
        search_keyword:'',
        items :[{title:'USER_ID',
        subtitle:'닉네임',
        action:'우편' }],
        headers: [
            { text: '아이디', value: 'user_id' },
            { text: '닉네임', value: 'user_nick' },
            { text: '가입일', value: 'regist_date' },
            { text: '정렬정보', value: 'sort_info' },
            { text: '우편/상세보기', value: 'mail' },
            // { text: '', value: 'delete' },
        ],
        headers_type_coin: [
            { text: '아이디', value: 'user_id' },
            { text: '닉네임', value: 'user_nick' },
            { text: '가입일', value: 'regist_date' },
            { text: '정렬정보', value: 'sort_info' },
            { text: '현금화', value: 'sort_info' },
            { text: '우편/상세보기', value: 'mail' },
            // { text: '', value: 'delete' },
        ],
        headers_type_gem: [
            { text: '아이디', value: 'user_id' },
            { text: '닉네임', value: 'user_nick' },
            { text: '가입일', value: 'regist_date' },
            { text: '정렬정보', value: 'sort_info' },
            { text: '우편/상세보기', value: 'mail' },
        ],
        headers_type_bp: [
            { text: '아이디', value: 'user_id' },
            { text: '닉네임', value: 'user_nick' },
            { text: '가입일', value: 'regist_date' },
            { text: '현재 채굴량', value: 'cur_bp' },
            { text: '우편/상세보기', value: 'mail' },
        ],
        headers_type_referee: [
            { text: '아이디', value: 'user_id' },
            { text: '닉네임', value: 'user_nick' },
            { text: '가입일', value: 'regist_date' },
            { text: '추천인수', value: 'sort_info' },
            { text: '추천인보기', value: 'sort_info' },
            { text: '우편/상세보기', value: 'mail' },
        ],
        user_sort_type: [
            { id: "RECENT", name: "최신순" },
            { id: "GEM", name: "현재 보유보석" },
            { id: "EARN_GEM_TOTAL", name: "누적보유보석" },
            { id: "COIN", name: "현재보유골드" },
            { id: "EARN_COIN_TOTAL", name: "누적 획득 골드" },
            { id: "BP", name: "현재 채굴량" },
            { id: "REFEREE", name: "추천인수" },
        ],
        headers_referees: [
            { text :'유저 아이디', value: 'USER_ID' },
            { text: '닉네임', value: 'NICK'},
            { text: '전화번호', value: 'PHONE'},
            { text: '적용중 채굴기', value: 'CUR_BP'},
            { text: '누적 친구코인 (REFEREE_COIN)', value: 'REFEREE_COIN', align: 'end'},
            { text: '친구지분율 (FRIEND_SHARE_PER)', value: 'FRIEND_SHARE_PER', align: 'center', sortable: true, width: '220px'},
            { text: '생성일', value: 'CREATE_DT'},
        ],
        selected_sort_type:"",
        search_result:[],
        total_count:0,
        dialog_referee_list_items:[],
        dialog_referee_list:false,
        saving_share_per_id: null,           // FRIEND_SHARE_PER 저장 중인 USER_ID
        share_per_drafts: {},                // USER_ID -> 편집 중 임시 값 (저장 전까지 정렬 미반영)
        gold_price: 0,
        gold_price_rate: 1.3,

        // ===== 유저 세스코 (어뷰징 분석) =====
        sesco_min_referees: 5,
        sesco_limit: 50,
        sesco_include_banned: false,
        sesco_risk_threshold: 60,
        sesco_loading: false,
        sesco_loaded: false,
        sesco_list: [],
        sesco_headers: [
            { text: 'USER_ID', value: 'USER_ID', width: '90px' },
            { text: 'NICK', value: 'NICK', width: '120px' },
            { text: '추천인수', value: 'REF_COUNT', align: 'end', width: '90px' },
            { text: '인증률', value: 'REFEREE_PHONE_VERIFIED_PCT', align: 'end', width: '90px' },
            { text: '평균 채굴', value: 'REFEREE_AVG_CUR_BP', align: 'end', width: '100px' },
            { text: '동일IP점유', value: 'REFEREE_TOP_SHARED_IP_PCT', align: 'end', width: '100px' },
            { text: 'distinct IP', value: 'REFEREE_DISTINCT_IP_COUNT', align: 'end', width: '90px' },
            { text: '위험점수', value: 'RISK_SCORE', align: 'center', width: '100px' },
            { text: '상태', value: 'IS_BANNED', align: 'center', width: '70px' },
            { text: '가입일', value: 'CREATE_DT', width: '160px' },
            { text: '액션', value: 'actions', sortable: false, align: 'center', width: '180px' },
        ],
        sesco_detail_dialog: false,
        sesco_detail_loading: false,
        sesco_detail_data: null,
        sesco_detail_headers: [
            { text: 'USER_ID', value: 'USER_ID', width: '90px' },
            { text: 'NICK', value: 'NICK', width: '110px' },
            { text: '폰', value: 'PHONE_VERIFIED', align: 'center', width: '60px' },
            { text: 'CUR_BP', value: 'CUR_BP', align: 'end', width: '100px' },
            { text: '마지막 IP', value: 'LAST_LOGIN_IP', width: '140px' },
            { text: '본인과 동일', value: 'SHARES_IP_WITH_OWNER', align: 'center', width: '100px' },
            { text: '상태', value: 'IS_BANNED', align: 'center', width: '70px' },
            { text: '가입일', value: 'CREATE_DT', width: '150px' },
            { text: '액션', value: 'actions', sortable: false, align: 'center', width: '90px' },
        ],
    }),

    async created()
    {
        let count = 30;
        this.selected_sort_type = "RECENT";
        try {
            const res = await carrygold.get_gold_price();
            const data = res?.response_data ?? res;
            this.gold_price = Number(data?.gold_price ?? 0);
        } catch (e) {
            console.error('골드 시세 로드 실패:', e);
            this.gold_price = 0;
        }
    },

    methods:{
        ...mapActions([
            'CARRYGOLD_GET_USERLIST_RECENT',
            'CARRYGOLD_GET_USERLIST_HAVE_GEM',
            'CARRYGOLD_GET_USERLIST_HAVE_COIN',
            'CARRYGOLD_GET_USERLIST_HAVE_BP',
            'CARRYGOLD_GET_USERLIST_REFEREE',
            'CARRYGOLD_GET_SEARCH_USER_LIST',
            'CARRYGOLD_DELETE_USER',
            'CARRYGOLD_GET_USER_REFEREE_LIST',
            'CARRYGOLD_SET_FRIEND_SHARE_PER',
            'CARRYGOLD_GET_USERLIST_SESCO',
            'CARRYGOLD_GET_USER_SESCO_DETAIL',
        ]),
        async clickDeleteUserBtn(user_id) {
            console.log('유저 하나 삭제 클릭됨')
            let packageName = this.$store.state.selected_game_package;
            if (confirm(`${user_id} 유저를 삭제하시겠습니까?`)) {
                await this.CARRYGOLD_DELETE_USER({packageName, user_id})
                alert("삭제 완료");
                let count = 30;
                let server_index = this.$store.state.selected_game_server;
                const requestResult = await this.GET_RECENT_USER_LIST({packageName  ,  server_index, count})
                console.log(requestResult)
                const userList = requestResult.user_list
                this.search_result = userList
            }
        },
        GetSortInfo(item){
            if(this.selected_sort_type == 'RECENT')
                return '';
            if(this.selected_sort_type == 'GEM')
                return item.GEM ?? 0;
            if(this.selected_sort_type == 'EARN_GEM_TOTAL')
                return item.TOTAL_EARN_GEM ?? 0;
            if(this.selected_sort_type == 'COIN')
                return item.COIN;
            if(this.selected_sort_type == 'EARN_COIN_TOTAL')
                return item.TOTAL_EARN_COIN;
            if(this.selected_sort_type == 'BP')
                return item.CUR_BP ?? 0;
            if(this.selected_sort_type == 'REFEREE')
                return item.REF_COUNT;
            return '';
        },
        formatNumber(value) {
            const n = Number(value);
            if (Number.isNaN(n)) return '0';
            return n.toLocaleString(undefined, { maximumFractionDigits: 8 });
        },
        formatCoin(value) {
            if (typeof value !== 'number') {
                const numValue = parseFloat(value) || 0;
                return Math.floor(numValue).toLocaleString();
            }
            return Math.floor(value).toLocaleString();
        },
        formatCoin_KRW(value) {
            const n = Number(value);
            if (Number.isNaN(n)) return '0';
            return Math.floor(n).toLocaleString();
        },
        OnClickUserInfo(_item)
        {
            this.loadingData = false;
            this.$router.push('/carrygold_user_info?USER_ID='+_item.USER_ID);
        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            this.$router.push('/carrygold_mail?USER_ID='+_item.USER_ID);
        },
        OnClick_SearchUser()
        {
            if(this.search_keyword.length < 1)
            {
                alert('검색어는 1자이상 입력해주세요');
                return;
            }

            let keyword = this.search_keyword;
            this.CARRYGOLD_GET_SEARCH_USER_LIST({keyword}).then((body_data)=>{
            let user_list = body_data.user_list;
            this.search_result = user_list;
        });
        },
        async Load_And_Setting(){
            console.log("Load_And_Setting");
            if(this.selected_sort_type == "RECENT"){
                if(this.$store.state.user_list_carrygold_sort_recent.length == 0){
                    await this.CARRYGOLD_GET_USERLIST_RECENT({count:100}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        store.commit("SET_CARRYGOLD_USERLIST_RECENT", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_carrygold_sort_recent;
                }
            } else if(this.selected_sort_type == "GEM") {
                if(this.$store.state.user_list_carrygold_sort_gem.length == 0){
                    await this.CARRYGOLD_GET_USERLIST_HAVE_GEM({count:100, type:'CUR'}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        store.commit("SET_CARRYGOLD_USERLIST_GEM", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_carrygold_sort_gem;
                }
            } else if(this.selected_sort_type == "EARN_GEM_TOTAL") {
                if(this.$store.state.user_list_carrygold_sort_gem_total.length == 0){
                    await this.CARRYGOLD_GET_USERLIST_HAVE_GEM({count:100, type:'TOTAL'}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        store.commit("SET_CARRYGOLD_USERLIST_EARN_GEM_TOTAL", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_carrygold_sort_gem_total;
                }
            } else if(this.selected_sort_type == "COIN") {
                  if(this.$store.state.user_list_carrygold_sort_point.length == 0){
                    await this.CARRYGOLD_GET_USERLIST_HAVE_COIN({count:100 , type:'CUR'}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        console.log("COIN : 다시 불러옴 ");
                        store.commit("SET_CARRYGOLD_USERLIST_COIN", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_carrygold_sort_point;
                }

            } else if(this.selected_sort_type == "EARN_COIN_TOTAL") {
                  if(this.$store.state.user_list_carrygold_sort_point_total.length == 0){
                    await this.CARRYGOLD_GET_USERLIST_HAVE_COIN({count:100 , type:'TOTAL'}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        console.log("EARN_COIN_TOTAL : 다시 불러옴 ");
                        store.commit("SET_CARRYGOLD_USERLIST_EARN_COIN_TOTAL", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_carrygold_sort_point_total;
                }
            } else if(this.selected_sort_type == "BP") {
                if(this.$store.state.user_list_carrygold_sort_bp.length == 0){
                    await this.CARRYGOLD_GET_USERLIST_HAVE_BP({count:100}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        console.log("BP : 다시 불러옴 ");
                        store.commit("SET_CARRYGOLD_USERLIST_BP", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_carrygold_sort_bp;
                }
            } else if(this.selected_sort_type == "REFEREE") {
                if(this.$store.state.user_list_carrygold_sort_referee.length == 0){
                    await this.CARRYGOLD_GET_USERLIST_REFEREE({count:100}).then((body_data)=>{
                        let userlist = body_data.user_list;
                        console.log("REFEREE : 다시 불러옴 ");
                        store.commit("SET_CARRYGOLD_USERLIST_REFEREE", {userlist})
                    });
                } else {
                    this.search_result = this.$store.state.user_list_carrygold_sort_referee;
                }
            }


        },
        Show_UserReferees(item){
            this.share_per_drafts = {};  // 다이얼로그 새로 열 때 편집중 값 초기화
            this.CARRYGOLD_GET_USER_REFEREE_LIST({user_id: item.USER_ID}).then((body_data)=>{
                this.dialog_referee_list_items = body_data.result || [];
                this.dialog_referee_list = true;
            });
        },
        isShareDirty(item){
            const draft = this.share_per_drafts[item.USER_ID];
            if (draft === undefined || draft === null || draft === '') return false;
            return Number(draft) !== Number(item.FRIEND_SHARE_PER);
        },
        async Save_FriendSharePer(item){
            if (!item) return;
            const draft = this.share_per_drafts[item.USER_ID];
            const value = Number(draft);
            if (!Number.isFinite(value) || value < 0.01 || value > 0.5) {
                alert('FRIEND_SHARE_PER는 0.01 ~ 0.5 사이의 값이어야 합니다.');
                return;
            }
            this.saving_share_per_id = item.USER_ID;
            try {
                await this.CARRYGOLD_SET_FRIEND_SHARE_PER({
                    user_id: item.USER_ID,
                    friend_share_per: value,
                });
                // 저장 성공 시점에만 실제 값을 갱신 → 정렬도 이때 반영됨
                this.$set(item, 'FRIEND_SHARE_PER', value);
                this.$delete(this.share_per_drafts, item.USER_ID);
                alert(`[${item.USER_ID}] FRIEND_SHARE_PER가 ${value}로 저장되었습니다.`);
            } catch (e) {
                console.error('FRIEND_SHARE_PER 저장 실패:', e);
                const msg = e?.err_info?.err_message || e?.message || '저장에 실패했습니다.';
                alert(msg);
            } finally {
                this.saving_share_per_id = null;
            }
        },
        Close_Referee_Dialog(){
            this.dialog_referee_list = false;
            this.share_per_drafts = {};
        },

        // ===== 유저 세스코 (어뷰징 분석) =====
        async LoadSescoList() {
            this.sesco_loading = true;
            try {
                const body = await this.CARRYGOLD_GET_USERLIST_SESCO({
                    min_referees: this.sesco_min_referees,
                    limit: this.sesco_limit,
                    include_banned: this.sesco_include_banned,
                });
                const list = (body && (body.user_list || body.result)) || [];
                this.sesco_list = Array.isArray(list) ? list : [];
                this.sesco_loaded = true;
            } catch (err) {
                console.error('[Sesco] 분석 로드 실패:', err);
                this.sesco_list = [];
                this.sesco_loaded = true;
                const msg = err?.err_info?.err_message || err?.message || '백엔드가 아직 준비되지 않았습니다.';
                alert(`유저 세스코 분석을 불러오지 못했습니다.\n${msg}`);
            } finally {
                this.sesco_loading = false;
            }
        },
        async OpenSescoDetail(item) {
            if (!item || !item.USER_ID) return;
            this.sesco_detail_dialog = true;
            this.sesco_detail_loading = true;
            this.sesco_detail_data = null;
            try {
                const body = await this.CARRYGOLD_GET_USER_SESCO_DETAIL({
                    user_id: item.USER_ID,
                    ip_log_days: 30,
                });
                // 백엔드가 stats.RISK_SCORE를 안 채워주면 프런트에서 보강
                const data = body && (body.response_data || body) || {};
                if (data.stats && (data.stats.RISK_SCORE === undefined || data.stats.RISK_SCORE === null)) {
                    data.stats.RISK_SCORE = this.computeRiskScore({
                        REFEREE_PHONE_VERIFIED_PCT: data.stats.PHONE_VERIFIED_PCT,
                        REFEREE_TOP_SHARED_IP_PCT: data.stats.TOP_SHARED_IP_PCT,
                        REFEREE_BANNED_COUNT: data.stats.BANNED_COUNT,
                        REF_COUNT: data.stats.TOTAL_REFEREES,
                        REFEREE_AVG_CUR_BP: data.stats.AVG_CUR_BP,
                        REFEREE_SAME_IP_AS_OWNER_COUNT: data.stats.SAME_IP_AS_OWNER_COUNT,
                    });
                }
                this.sesco_detail_data = data;
            } catch (err) {
                console.error('[Sesco] 상세 분석 실패:', err);
                const msg = err?.err_info?.err_message || err?.message || '백엔드가 아직 준비되지 않았습니다.';
                alert(`상세 분석 로드 실패: ${msg}`);
                this.sesco_detail_data = null;
            } finally {
                this.sesco_detail_loading = false;
            }
        },
        computeRiskScore(it) {
            // 백엔드 누락 시 동일 산식으로 프런트에서 위험점수 산출
            const refCount = Math.max(Number(it.REF_COUNT) || 0, 1);
            const phonePct = Number(it.REFEREE_PHONE_VERIFIED_PCT) || 0;
            const topIpPct = Number(it.REFEREE_TOP_SHARED_IP_PCT) || 0;
            const bannedCnt = Number(it.REFEREE_BANNED_COUNT) || 0;
            const avgBp = Number(it.REFEREE_AVG_CUR_BP) || 0;
            const sameIp = Number(it.REFEREE_SAME_IP_AS_OWNER_COUNT) || 0;

            const phoneRisk = 35 * (1 - phonePct / 100);
            const ipRisk = 25 * Math.min(1, topIpPct / 100);
            const banRisk = 15 * (bannedCnt / refCount);
            const bpClamp = Math.max(0, Math.min(1, avgBp / 50));
            const bpRisk = 15 * (1 - bpClamp);
            const sameIpRisk = 10 * (sameIp / refCount);

            const score = phoneRisk + ipRisk + banRisk + bpRisk + sameIpRisk;
            return Math.max(0, Math.min(100, Math.round(score)));
        },
        riskColor(score) {
            const n = Number(score) || 0;
            if (n >= 80) return 'red darken-2';
            if (n >= 60) return 'red';
            if (n >= 40) return 'orange';
            if (n >= 20) return 'amber darken-2';
            return 'green';
        },
        riskIcon(score) {
            const n = Number(score) || 0;
            if (n >= 60) return 'mdi-alert-octagon';
            if (n >= 40) return 'mdi-alert';
            return 'mdi-shield-check';
        },

    },
    computed: {
        isLive(){
            return config.isLive;
        },
        sesco_list_decorated() {
            // RISK_SCORE 가 없는 항목은 프런트에서 계산해 채워준다.
            return (this.sesco_list || []).map((it) => {
                const risk = (it.RISK_SCORE !== undefined && it.RISK_SCORE !== null)
                    ? Number(it.RISK_SCORE)
                    : this.computeRiskScore(it);
                return { ...it, RISK_SCORE: risk };
            });
        },
        sescoStats() {
            const list = this.sesco_list_decorated;
            if (!list || list.length === 0) {
                return { total: 0, suspect: 0, avgReferees: 0, avgPhonePct: 0 };
            }
            const total = list.length;
            const suspect = list.filter(it => Number(it.RISK_SCORE) >= this.sesco_risk_threshold).length;
            const avgReferees = list.reduce((s, it) => s + (Number(it.REF_COUNT) || 0), 0) / total;
            const phoneVals = list.map(it => Number(it.REFEREE_PHONE_VERIFIED_PCT)).filter(v => Number.isFinite(v));
            const avgPhonePct = phoneVals.length === 0 ? 0 : phoneVals.reduce((a, b) => a + b, 0) / phoneVals.length;
            return { total, suspect, avgReferees, avgPhonePct };
        },
        sescoSuspectCount() {
            return this.sescoStats.suspect;
        },
    },
    components:{
    },
    watch :{
            '$store.state.selected_game_package': function() {
            let packageName = this.$store.state.selected_game_package;
            let server_index = this.$store.state.selected_game_server;
            let count = 30;
            this.CARRYGOLD_GET_RECENT_USER_LIST({packageName , server_index, count}).then((body_data)=>{
            let user_list = body_data.user_list;
            console.log("JS:"+JSON.stringify(user_list));
            this.search_result = user_list;
        });
        },
        '$store.state.selected_game_server': function() {
            let packageName = this.$store.state.selected_game_package;
            let server_index = this.$store.state.selected_game_server;
            let count = 30;
            this.CARRYGOLD_GET_RECENT_USER_LIST({packageName , server_index, count}).then((body_data)=>{
            let user_list = body_data.user_list;
            console.log("JS:"+JSON.stringify(user_list));
            this.search_result = user_list;
        });
        },
        selected_sort_type(newVal) {
            let sortType = newVal;
            console.log(this.selected_sort_type);
            this.Load_And_Setting();
        },
        '$store.state.user_list_carrygold_sort_recent': function() {
            this.search_result = this.$store.state.user_list_carrygold_sort_recent;
        },
        '$store.state.user_list_carrygold_sort_gem': function() {
            this.search_result = this.$store.state.user_list_carrygold_sort_gem;
        },
        '$store.state.user_list_carrygold_sort_gem_total': function() {
            this.search_result = this.$store.state.user_list_carrygold_sort_gem_total;
        },
        '$store.state.user_list_carrygold_sort_point': function() {
            this.search_result = this.$store.state.user_list_carrygold_sort_point;
        },
        '$store.state.user_list_carrygold_sort_point_total': function() {
            this.search_result = this.$store.state.user_list_carrygold_sort_point_total;
        },
        '$store.state.user_list_carrygold_sort_bp': function() {
            this.search_result = this.$store.state.user_list_carrygold_sort_bp;
        },
        '$store.state.user_list_carrygold_sort_referee': function() {
            this.search_result = this.$store.state.user_list_carrygold_sort_referee;
        }


    }
};
</script>

<style scoped>
.userlist-header {
  background: var(--cms-toolbar-gradient, linear-gradient(135deg, #0277BD 0%, #0288D1 50%, #039BE5 100%));
  padding: 16px;
}
.userlist-header__title {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}
.userlist-header__search {
  margin: 0;
}
@media (max-width: 600px) {
  .userlist-header {
    padding: 12px;
  }
  .userlist-header__title {
    font-size: 17px;
    margin-bottom: 8px;
  }
  .v-data-table {
    overflow-x: auto;
  }
}

/* ===== 유저 세스코 (어뷰징 분석) ===== */
.sesco-header {
  background: linear-gradient(135deg, #B71C1C 0%, #C62828 50%, #E53935 100%);
  padding: 16px;
}
.sesco-header__title {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
}
.sesco-header__controls {
  margin: 0;
}
.sesco-field-hint {
  color: rgba(255, 255, 255, 0.85);
  font-size: 11px;
  line-height: 1.35;
  margin-top: 4px;
  padding: 0 4px;
  letter-spacing: 0.1px;
  cursor: help;
  display: inline-block;
}
.sesco-field-hint:hover {
  color: #fff;
  text-decoration: underline dotted;
}
::v-deep .sesco-shared-ip-row {
  background-color: #FFEBEE !important;
}
::v-deep .sesco-shared-ip-row:hover {
  background-color: #FFCDD2 !important;
}
@media (max-width: 600px) {
  .sesco-header {
    padding: 12px;
  }
  .sesco-header__title {
    font-size: 17px;
    margin-bottom: 8px;
  }
}
</style>
